<template>
  <div id="app" style="padding: 0.5rem 0; text-align: left" class="vue-dpn">
    
    <div
      style="position: fixed; top: 0; left: 0; right: 0; z-index: 999"
      class="payment"
    >
      <van-nav-bar title="发票" @click-left="goBack" left-arrow>
        <template #right>
          <van-icon name="plus" @click="goToNewPayment" />
        </template>
      </van-nav-bar>
    </div>



    <van-pull-refresh v-model="isLoading" @refresh="onRefresh">
      <div style="padding: 46px 0.4rem 0 0.4rem">
        <div class="cus-row cus-row-v-m">
          <div class="cus-row-col-12">
            <div class="in-bl-v-m">
              <div
                style="
                  display: inline-block;
                  width: 0.72rem;
                  height: 0.72rem;
                  border-radius: 100%;
                  border: 0.01rem solid #e4e4e4;
                "
              >
                <img
                  round
                  style="width: 100%;height: 100%;"
                  src="../assets/images/logo.jpg"
                />
              </div>
            </div>
            <div class="in-bl-v-m" style="margin-left: 0.2rem">
              <div>
                <div class="in-bl ffm f-c-212120 s-32-45">{{ user.name }}</div>
                <div
                  class="in-bl ffr f-c-999999 s-20-28"
                  style="margin-left: 0.2rem"
                >
                  {{ user.mobile }}
                </div>
              </div>
              <!-- <div class="ffr f-c-999999 s-24-33">授权店</div> -->
            </div>
          </div>
          <!--          <div class="cus-row-col-3 t-al-r">-->
          <!--          </div>-->
        </div>

        <div
          style="
            margin-top: 0.4rem;
            box-shadow: 0.03rem 0.05rem 0.43rem 0.02rem rgba(49, 224, 172, 0.3);
            padding: 0.32rem 0.49rem;
            background-image: linear-gradient(90deg, #0a0701 0%, #666666 100%);
            border-radius: 0.25rem;
          "
          id="div2"
        >
          <div class="ffr s-24-33" style="color: rgba(255, 255, 255, 0.75)">
            待处理
          </div>
          <div style="margin-top: 0.24rem" class="f-c-ffffff s-72-84 ffm">
            {{ static_info.invoice_today_new }}
          </div>
        <div style="margin-top: 0.49rem" class="cus-row">
            <div class="cus-row-col-3">
              <div class="f-c-ffffff ffm s-36-50">
                {{ static_info.outcome_today_new }}
              </div>
              <div class="ffr s-24-33" style="color: rgba(255, 255, 255, 0.75)">
                已开票
              </div>
            </div>

            <div class="cus-row-col-6 t-al-c">
              <div class="in-bl t-al-l">
                <div class="f-c-ffffff ffm s-36-50 t-al-l">
                  {{ static_info.income_today_new }}
                </div>
                <div
                  class="ffr s-24-33"
                  style="color: rgba(255, 255, 255, 0.75)"
                >
                  待审核
                </div>
              </div>
            </div>

            <div class="cus-row-col-3">
              <div class="f-c-ffffff ffm s-36-50">
                <span style="display: inline-block; vertical-align: middle">{{
                  static_info.invoice_today_new +  static_info.outcome_today_new +  static_info.income_today_new
                }}</span>
              </div>
              <div class="ffr s-24-33" style="color: rgba(255, 255, 255, 0.75)">
                <span>累计总数</span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!--            <div style="margin-top: .56rem;" class="cus-row cus-row-v-m">-->
      <!--                <div class="cus-row-col-6"><span class="f-c-000000 ffm s-40-56">未完成订单</span></div>-->
      <!--            </div>-->

      <div
        style="
          margin-top: 0.4rem;
          height: 0.45rem;
          background-color: #f8f8f8;
          margin-left: -0.4rem;
          margin-right: -0.4rem;
          position: relative;
        "
      >
        <!--                <div style="background-color: #f8f8f8;height: 100%"></div>-->
        <div
          style="
            position: absolute;
            top: 0;
            left: 0;
            right: 0;
            bottom: 0;
            background-color: #f8f8f8;
          "
        ></div>
      </div>

      <div style="padding: 0 0.4rem">
        <div
          style="padding-right: -0.4rem; padding-left: -0.4rem"
          :class="{ 'filter-fixed': filterFixed, filter_content: !filterFixed }"
        >
          <van-dropdown-menu>
            <van-dropdown-item v-model="value1" :options="option1" />
            <van-dropdown-item v-model="value2" :options="option2" />
          </van-dropdown-menu>
        </div>

        <div class="pending-list" style="padding-bottom: 2rem">
          <div v-if="currentListLoading">
            <van-skeleton title :row="3" />
          </div>

          <div v-if="!currentListLoading">
            <template v-if="currentList.length">
              <div
                class="pending-list-item"
                v-for="(item) in currentList"
                :key="item.id"
              >
              <div @click="goDetail(item)">
                <div class="cus-row cus-row-v-m">
                  <div class="cus-row-col-12">
                    <span class="ffm f-c-212120 s-28-40">
                      {{ getDisplayName(item) }}
                    </span>
                  </div>
                </div>

                <div style="margin-top: 0.2rem; display:flex; align-items:center;" class="in-bl-line">
                  <span class="ffr f-c-757575 s-28-40" style="font-weight: bold; display:inline-block; vertical-align: middle;">
                    金额：{{ item.currency_code || 'CNY' }} {{ item.price }}
                  </span>
                  <span v-if="parseInt(item.is_urgent) === 1" class="urgent-tag" style="margin-left: .16rem; vertical-align: middle;">
                    <van-icon name="fire-o" style="vertical-align: middle; margin-right: 4px;" />
                    已加急
                  </span>
                </div>

                <div class="barrie-line-sa" style="margin-top: 0.4rem"></div>
              </div>

              <div class="cus-row cus-row-v-m" style="margin-top: 0.16rem">
                <div class="cus-row-col-8">
                  <span class="ffr f-c-b5b5b5 s-24-33">付款单号：{{ item.bill_no || '-' }}</span>
                </div>
                <div class="cus-row-col-4 t-al-r">
                  <span class="status-badge" :class="statusClass(item.status)">
                    <van-icon :name="statusIcon(item.status)" style="vertical-align: middle; margin-right: 4px;" />
                    {{ item.status_txt || statusText(item.status) }}
                  </span>
                </div>
              </div>

                  

              <div
                style="
                  margin-top: 0.3rem;
                  margin-left: -0.3rem;
                  margin-right: -0.3rem;
                  border-top: 1px solid #e4e4e4;
                  margin-bottom: -0.32rem;
                "
                
              >
                <div
                  class="cus-row cus-row-v-m opr-line"
                  style="color: #1889f8"
                >
                  <div
                    class="cus-row-col-6 t-al-c"
                    @click="doCopy(item.bill_no)"
                  >
                                                   <div class="in-bl-v-m">
                                                      <img src="../assets/images/copy.png" style="width: 16px;"/>
                                                  </div>
                    <span class="opr-span">复制单号</span>
                  </div>

                  <div class="cus-row-col-6 t-al-c" @click="goDetail(item)">
                    <div class="in-bl-v-m">
                                                      <img src="../assets/images/eyes.png" style="width: 20px;"/>
                                                  </div>
                    <span class="opr-span" style="color:#000000 !important;">详情</span>
                  </div>
                  <!--                            <div class="cus-row-col-4 t-al-c" @click="goDetail(item)">-->
                  <!--                                <div class="in-bl-v-m">-->
                  <!--                                    <van-icon name="eye-o" />-->
                  <!--                                </div>-->
                  <!--                                <span class="opr-span">查看</span>-->
                  <!--                            </div>-->
                </div>
              </div>
            </div>
            </template>

            <div
              v-if="!currentList.length"
              class="t-al-c"
              style="margin-top: 0.96rem"
            >
              <img
                src="~@/assets/images/no_order.png"
                style="width: 2rem; display: inline-block"
              />
            </div>

            <div
              v-if="!currentList.length"
              class="t-al-c s-26-37 ffr f-c-b5b5b5"
              style="margin-top: 0.56rem"
            >
              暂无数据
            </div>
          </div>

          <!--                <div class="t-al-c in-bl-line" style="margin-top: .48rem;">-->
          <!--                    <div style="padding: 0.14rem 0.28rem;background-color: rgba(255, 255, 255, 0.75);border-radius: 0.3rem;border: solid 0.02rem #e4e4e4;color:#1889f8;display: inline-block;" @click="showMeiqia">-->
          <!--                        <van-icon name="service-o" size=".33rem" :style="{'vertical-align': 'middle'}"/>-->
          <!--                        <span class="f-c-1889f8 s-24-33 ffm in-bl" style="vertical-align: middle;margin-left: 0.1rem;">在线客服</span>-->
          <!--                    </div>-->
          <!--                </div>-->
        </div>
      </div>
    </van-pull-refresh>

    <tar-bar @showqr="showqr"></tar-bar>
    <van-popup
      v-model="show"
      position="bottom"
      closeable
      close-icon-position="top-right"
      :style="{ height: 'auto' }"
      :close-on-click-overlay="false"
      ref="pop"
    >
      <div
        style="
          background-color: #ffffff;
          padding: 0.72rem 0.48rem 0.48rem 0.48rem;
        "
      >
        <div class="wx-text">微信扫一扫，申请分期</div>

        <div
          style="
            margin-top: 0.16rem;
            font-family: PingFangSC-Regular;
            font-size: 0.28rem;
            font-weight: normal;
            color: #222222;
          "
        >
          请向客户出示此二维码，长按图片/截屏保存到相册
        </div>

        <div
          style="
            background-color: #1889f9;
            padding: 0.14rem 0.16rem 0.18rem 0.16rem;
            border-radius: 0.16rem;
            margin-top: 0.48rem;
          "
        >
          <div
            style="
              background-color: #ffffff;
              border-radius: 0.08rem;
              padding-bottom: 90%;
              position: relative;
            "
          >
            <div class="ab-t-t-x-y" style="width: 70%; font-size: 0">
              <img :src="qrcodePath" style="width: 100%" />
            </div>
          </div>

          <div style="margin-top: 0.28rem" class="in-bl-line">
            <div
              style="
                width: 0.58rem;
                height: 0.58rem;
                background-color: #ffffff;
                border-radius: 0.72rem;
                border: solid 0.04rem #fffefe;
                display: inline-block;
                vertical-align: middle;
              "
            >
              <van-image round width="0.58rem" height="0.58rem" />
            </div>

            <div
              class="in-bl"
              style="
                margin-left: 0.28rem;
                font-family: PingFangSC-Medium;
                font-size: 0.32rem;
                color: #ffffff;
                vertical-align: middle;
              "
            >
              {{ edu_name }}
              <span style="font-family: PingFangSC-Light">客户分期二维码</span>
            </div>
          </div>
        </div>
      </div>
    </van-popup>
  </div>
</template>


<script>
import common from "@/assets/js/common";
import TarBar from "../components/TaxTarBar";
import { Dialog, Toast } from "vant";
import _ from "underscore";
import moment from "moment";

export default {
  name: "HelloWorld",
  props: {
    msg: String,
  },
  data: function () {
    return {
      periodArr: [3, 6, 9, 12, 24],
      period: "",
      price: "",
      class_name: "",
      pending_list: [],
      show: false,
      qrcodePath: common.dynamicHost() + "/entry_qrcode.png",
      userInfo: {},
      edu_name: {},
      edu_phone: {},
      pending_total_amount: 0,
      amount_all: 0,
      count_all: 0,
      count_current_month: 0,
      isLoading: false,
      static_info: {},
      option1: [
        { text: "待处理", value: 0 },
      ],
      option2: [
        { text: "全部时间", value: 0 },
        { text: "今天", value: 1 },
        { text: "本月", value: 2 },
        // { text: "今年", value: 3 },
      ],
      value1: 0,
      value2: 1,
      filterFixed: false,
      currentListLoading: true,
      user: {},
      header_img: "",
    };
  },
  components: {
    TarBar,
  },
  methods: {
    getDisplayName(item) {
      const type = Number(item.type)
      if (type === 1) {
        // 合同付款：显示收款开户名
        return item.bank_account_name || '-'
      } else if (type === 2) {
        // 报春内转/同行付款：显示供应商名称
        return item.supplier_name || '-'
      } else if (type === 3) {
        // 外币付款：显示账户名称
        return item.foreign_account_name || '-'
      }
      return '-'
    },
    goBack(){
      this.$router.push({ path: "/" });
    },
    goToNewPayment() {
      this.$router.push({ path: "/new_payment" });
    },

    copyLoan(item){
      console.log("复制合同")
      console.log(item)


      //如果是特殊的，那么复制的时候有复制带游客信息和不带游客信息
      if( common.isTestMode() ){

        return
      }



      Dialog.confirm({
        title: "确认要复制当前合同吗?",
      })
        .then(() => {
          // common.setSaAuth("");
          // common.setSaAuthWithRefresh("");
          // location.href = "sa_login";

          common
        .cusHttp(
          this,
          "/admin_user.php?action=copy_contract",
          { id: item.id },
          "post"
        )
        .then((res) => {
          // console.log("user_info返回", res);
          res = JSON.parse(res.data);
          if (res.errcode == 0) {
            this.goDetail(res.data)
          }else{
            common.mAlert(this, res.errmsg);
          }
        });


        })
        .catch(() => {});
    },

    showMeiqia() {},
    onRefresh() {
      this.isLoading = false;
      location.reload();
    },
    doCopy: function (text) {
      let _self = this;
      this.$copyText(text).then(
        function (e) {
          common.mAlert(_self, "复制成功");
        },
        function (e) {
          common.mAlert(_self, "复制失败");
        }
      );
    },
    add() {
      location.href = "sa_fill";
    },
    setPeriod(period) {
      this.period = period;
      // console.log(period);
      //要用上选择器了
      var objs = document.querySelectorAll(".term-item-active");
      for (var i = 0, j = objs.length; i < j; i++) {
        objs[i].classList.remove("term-item-active");
      }
      var classList = document
        .querySelector('div[data-period="' + period + '"]')
        .classList.add("term-item-active");
      console.log(classList);
    },
    nextStep() {
      //验证
      if (!this.class_name) {
        // this.$layer.msg('请输入课程名称')
        common.mAlert(this, "请输入课程名称");
        return;
      }

      if (!this.price) {
        common.mAlert(this, "请输入课程金额");
        return;
      }

      if (!this.period) {
        common.mAlert(this, "请选择课程期数");
        return;
      }

      common.authRequest({
        url: common.dynamicHost() + "/user/save-fill",
        page: this,
        type: "get",
        data: {
          class_name: this.class_name,
          period: this.period,
          price: this.price,
        },
        indicator: true,
        success: function (res) {
          if (res.status) {
            location.href = "info";
          }
        },
        error: function () {},
      });
    },
    initPage() {
      // alert(33)

      common.cusHttp(this, "/admin_user.php?action=user_info", {}, "get").then((res) => {
        console.log("user_info返回", res)
        res = JSON.parse(res.data)
        if (res.code == 0) {
          this.user = res.result
          // console.log(JSON.stringify(res.data.loan_list));
          // this.list = res.data.loan_list;
        }
      });


      // 获得付款统计数据
      common.cusHttp(this, "/admin_user.php?action=payment_static_info", {category: 3}, "get").then((res) => {
        console.log("user_info返回", res)
        res = JSON.parse(res.data)
        if (res.status ) {
          this.static_info = res.data
          // console.log(JSON.stringify(res.data.loan_list));
          // this.list = res.data.loan_list;
        }
      });


      
      const params = {category: 3}
      common.cusHttp(this, "/admin_user.php?action=payment_list", params, "get").then((res) => {
        console.log("payment_list返回", res)
        res = JSON.parse(res.data)
        if (res.errcode == 200 ) {
          this.pending_list = res.result.data
          this.currentListLoading = false
        }
      });


      // console.log('请求网络')
      // common.commonHttp('/index/dealer-quali-info',{dealer_id: common.getAuth()},'get').then((res)=>{

      //   console.log('请求值')
      //   console.log(res)

      //   if( res.data.status == 1 )
      //   {

      //     console.log('这里去赋值')
      //     console.log(res.data.data)

      //     // this.pending_list = res.data.pending_list
      //     this.user = res.data.data.dealer
      //     this.header_img = this.$common.polishingImg(this.user.header_img)
      //     this.pending_total_amount = res.data.data.audit
      //     this.amount_all = res.data.data.year_total;
      //     this.count_all = res.data.data.total;
      //     this.count_current_month = res.data.data.month_total;
      //     Toast.clear()

      //     this.pending_list = res.data.data.list

      //     this.currentListLoading = false

      //   }
      //   Toast.clear()

      // }).catch((res=>{
      //   Toast.clear()
      // }));
    },
    loginOut() {
      Dialog.confirm({
        title: "确认退出登录?",
      })
        .then(() => {
          common.setSaAuth("");
          common.setSaAuthWithRefresh("");
          location.href = "sa_login";
        })
        .catch(() => {});
    },
    showqr(value) {
      this.show = true;
    },
    goDetail(item) {
      this.$router.push({ path: "new_tax?id=" + item.id });
    },
    goFill() {
      location.href = "sa_fill";
    },
    goFinish() {
      location.href = "sa_done_list";
    },
    cancelLoan(item) {
      let stageArr = ["101", "201", "301"];
      if (stageArr.indexOf(item.stage) === -1) {
        return "";
      }
      this.goDetail(item);
    },
    editLoan(item) {
      let stageArr = ["101", "201", "301"];
      if (stageArr.indexOf(item.stage) === -1) {
        return "";
      }

      this.goDetail(item);
    },
    canCancel(item) {
      let stageArr = ["101", "201", "301"];
      if (stageArr.indexOf(item.stage) !== -1) {
        return true;
      }
      return false;
    },
    canEdit(item) {
      let stageArr = ["101", "201", "301"];
      if (stageArr.indexOf(item.stage) !== -1) {
        return true;
      }
      return false;
    },
    getLast1Month() {
      let now = new Date();
      let year = now.getFullYear();
      let month = now.getMonth() + 1; //0-11表示1-12月
      let day = now.getDate();
      let dateObj = {};
      if (parseInt(month) < 10) {
        month = "0" + month;
      }
      if (parseInt(day) < 10) {
        day = "0" + day;
      }

      dateObj.now = year + "-" + month + "-" + day;

      if (parseInt(month) == 1) {
        //如果是1月份，则取上一年的10月份
        dateObj.last = parseInt(year) - 1 + "-12-" + day;
        return dateObj;
      }

      var preSize = new Date(year, parseInt(month) - 1, 0).getDate(); //开始时间所在月的总天数
      if (preSize < parseInt(day)) {
        // 开始时间所在月的总天数<本月总天数，比如当前是5月30日，在2月中没有30，则取下个月的第一天(3月1日)为开始时间
        let resultMonth =
          parseInt(month) < 10 ? "0" + parseInt(month) : parseInt(month);
        dateObj.last = year + "-" + resultMonth + "-01";
        return dateObj;
      }

      if (parseInt(month) <= 10) {
        dateObj.last = year + "-0" + (parseInt(month) - 1) + "-" + day;
        return dateObj;
      } else {
        dateObj.last = year + "-" + (parseInt(month) - 1) + "-" + day;
        return dateObj;
      }
    },
    getLastWeek() {
      return {
        now: moment().format("YYYY-MM-DD"),
        last: moment().subtract("days", 6).format("YYYY-MM-DD"),
      };
    },
    getLast3Month() {
      let now = new Date();
      let year = now.getFullYear();
      let month = now.getMonth() + 1; //0-11表示1-12月
      let day = now.getDate();
      let dateObj = {};
      if (parseInt(month) < 10) {
        month = "0" + month;
      }
      if (parseInt(day) < 10) {
        day = "0" + day;
      }

      dateObj.now = year + "-" + month + "-" + day;

      if (parseInt(month) == 1) {
        //如果是1月份，则取上一年的10月份
        dateObj.last = parseInt(year) - 1 + "-10-" + day;
        return dateObj;
      }
      if (parseInt(month) == 2) {
        //如果是2月份，则取上一年的11月份
        dateObj.last = parseInt(year) - 1 + "-11-" + day;
        return dateObj;
      }
      if (parseInt(month) == 3) {
        //如果是3月份，则取上一年的12月份
        dateObj.last = parseInt(year) - 1 + "-12-" + day;
        return dateObj;
      }

      var preSize = new Date(year, parseInt(month) - 3, 0).getDate(); //开始时间所在月的总天数
      if (preSize < parseInt(day)) {
        // 开始时间所在月的总天数<本月总天数，比如当前是5月30日，在2月中没有30，则取下个月的第一天(3月1日)为开始时间
        let resultMonth =
          parseInt(month) - 2 < 10
            ? "0" + parseInt(month) - 2
            : parseInt(month) - 2;
        dateObj.last = year + "-" + resultMonth + "-01";
        return dateObj;
      }

      if (parseInt(month) <= 10) {
        dateObj.last = year + "-0" + (parseInt(month) - 3) + "-" + day;
        return dateObj;
      } else {
        dateObj.last = year + "-" + (parseInt(month) - 3) + "-" + day;
        return dateObj;
      }
    },
    statusText(s){
      const map = {1:'待审核',2:'待开票',3:'审核不通过',4:'已开票',5:'已撤销',6:'开票失败'}
      return map[parseInt(s)] || '-'
    },
    statusClass(s){
      const st = parseInt(s)
      if(st === 1){ return 'badge-warn' }
      if(st === 2){ return 'badge-info' }
      if(st === 3){ return 'badge-danger' }
      if(st === 4){ return 'badge-success' }
      if(st === 5){ return 'badge-default' }
      if(st === 6){ return 'badge-danger' }
      return 'badge-info'
    },
    statusIcon(s){
      const st = parseInt(s)
      if(st === 1){ return 'clock-o' }
      if(st === 2){ return 'cash-o' }
      if(st === 3){ return 'close' }
      if(st === 4){ return 'passed' }
      if(st === 5){ return 'warning-o' }
      if(st === 6){ return 'close' }
      return 'info-o'
    }
  },
  created: function () {
    // common.setTitle("");
  },
  computed: {
    btn_lock: function () {
      return true;
    },
    pending_list_count() {
      if (!this.pending_list) {
        return 0;
      }

      return this.pending_list.length;
    },
    currentList() {
      // 状态过滤：待处理=待审核(1)+待付款(2)，已付款=4
      let targetList = [];
      if (this.value1 == 4) {
        for (let i = 0, j = this.pending_list.length; i < j; i++) {
          if (parseInt(this.pending_list[i].status) === 4) {
            targetList.push(this.pending_list[i]);
          }
        }
      } else {
        for (let i = 0, j = this.pending_list.length; i < j; i++) {
          const st = parseInt(this.pending_list[i].status)
          if (st === 1 || st === 2) {
            targetList.push(this.pending_list[i]);
          }
        }
      }

      console.log("过滤前的值");
      console.log(targetList);

      //按照日期筛选
      let targetList2 = [];
      if (this.value2 == 1) {
        //今日
        for (let i = 0, j = targetList.length; i < j; i++) {
          let today_date = moment().format("YYYY-MM-DD");
          const d = (targetList[i].created_at || '')
          if (d.substr(0, 10) == today_date) {
            targetList2.push(targetList[i]);
          }
        }

        // targetList2 = targetList
      } else if (this.value2 == 2) {
        //近一月
        for (let i = 0, j = targetList.length; i < j; i++) {
          let current_month = moment().format("YYYY-MM");
          const d = (targetList[i].created_at || '')
          if (d.indexOf(current_month) !== -1) {
            targetList2.push(targetList[i]);
          }
        }

        // targetList2 = targetList
      } else if (this.value2 == 3) {
        //近三月
        //近一月
        for (let i = 0, j = targetList.length; i < j; i++) {
          let current_month = moment().format("YYYY");
          const d = (targetList[i].created_at || '')
          if (d.indexOf(current_month) !== -1) {
            targetList2.push(targetList[i]);
          }
        }
      } else {
        targetList2 = targetList;
      }

      console.log("过滤后的值");
      console.log(targetList2);

      return targetList2;

      //时间过滤，今日，近一月，进三月
    },
  },
  mounted() {
    if (!common.getAuth()) {
      this.$router.push({ path: "/auth" });
      return;
    }

    //移除vue-dpn
    common.removeDpnClass();
    this.initPage();
  },
};
</script>


<style scoped>
html,
body {
  background-color: #f5f5f5 !important;
}

.filter_content {
  margin-left: -0.4rem !important;
  margin-right: -0.4rem !important;
}

.filter-fixed {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 99;
  border-bottom: 1px solid #e4e4e4;
  box-shadow: 0 0 0.43rem 0 rgba(0, 0, 0, 0.06);
}

.opr-span {
  color: #212121;
  display: inline-block;
  vertical-align: middle;
  margin-left: 0.15rem;
  font-size: 0.24rem;
  line-height: 0.8rem;
}

.copy-text {
  border: 1px solid #e4e4e4;
  border-radius: 0.33rem;
  padding: 0.02rem 0.1rem;
  margin-left: 0.04rem;
}

#app {
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none; /*禁用页面内容选中和复制操作*/
  -webkit-touch-callout: none; /*禁用长按页面时的弹出菜单(iOS下有效)*/
  -webkit-tap-highlight-color: rgba(
    0,
    0,
    0,
    0
  ); /*去掉点击链接和文本框对象时默认的灰色半透明覆盖层(iOS)或者虚框(Android)*/
}

#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}
#nav {
  padding: 30px;
}

#nav a {
  font-weight: bold;
  color: #2c3e50;
}

#nav a.router-link-exact-active {
  color: #42b983;
}

.in-bl {
  display: inline-block;
}

.term-item {
  background: #ffffff;
  border: 0.0325rem solid #cccccc;
  border-radius: 0.125rem;
  line-height: 1.25rem;
  width: 3rem !important;
  text-align: center;
  font-family: PingFangSC-Regular;
  font-size: 0.5rem;
  color: #333333;
  display: inline-block;
  margin-right: 0.25rem;
}

.term-item-active {
  border: 0.0325rem solid #fce701;
  background-color: #fce701;
}

.cheese_footer {
  font-family: PingFangSC-Regular;
  font-size: 0.3125rem;
  color: #b2b2b2;
  text-align: center;
  line-height: 0.4375rem;
}

.fix_footer {
  position: absolute;
  left: 50%;
  bottom: 2.5rem;
  text-align: center;
  z-index: 99;
}

.bottom_footer {
  margin-bottom: 0.5rem;
  margin-top: 0.5rem;
}

.new-btn {
  line-height: 1rem;
  padding: 0 1rem;
  border-radius: 1rem;
  background-color: #1989fa;
  color: #ffffff;
  font-size: 0.4rem;
  transform: translateX(-50%);
}

.pending-list {
  margin-bottom: 2rem;
}

.pending-list-item {
  margin-top: 0.32rem;
  padding: 0.32rem 0.3rem;
  background-color: #ffffff;
  /*box-shadow: 0.03rem 0.05rem 0.43rem 0.02rem*/
  /*rgba(0, 0, 0, 0.06);*/
  border-radius: 0.16rem;
  border: 1px solid #e4e4e4;
}

.status-btn {
  background-color: #f5f5f5;
  border-radius: 0.24rem;
  padding: 0 0.37rem 0 0.21rem;
  line-height: 0.45rem;
  font-family: PingFangSC-Regular;
  font-size: 0.24rem;
  color: #111111;
  display: inline-block;
  position: relative;
}

.status-btn:after {
  position: absolute;
  right: 0.21rem;
  top: 50%;
  -webkit-transform: translateY(-50%);
  transform: translateY(-50%);
  width: 0.08rem;
  height: 0.12rem;
  background: url("");
  background-size: 0.08rem 0.12rem;
}

.status-badge{
  display: inline-flex;
  align-items: center;
  padding: 0 .18rem;
  line-height: .5rem;
  border-radius: .25rem;
  font-size: .26rem;
}
.badge-warn{ background: #fff7e6; color: #d46b08; }
.badge-info{ background: #e6f7ff; color: #096dd9; }
.badge-danger{ background: #fff1f0; color: #a8071a; }
.badge-success{ background: #f6ffed; color: #389e0d; }
.badge-default{ background: #f0f0f0; color: #8c8c8c; }

.urgent-tag{
  display: inline-flex;
  align-items: center;
  margin-top: .12rem;
  padding: 0 .18rem;
  line-height: .44rem;
  border-radius: .22rem;
  font-size: .24rem;
  background: #fff1f0;
  color: #cf1322;
}

.wx-text {
  font-family: PingFangSC-Light;
  font-size: 0.56rem;
  color: #202021;
}

.opr-line .cus-row-col-6:nth-child(1) {
  border-right: 1px solid #e4e4e4;
  box-sizing: border-box;
}
</style>
